var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNuoliAlasRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 13,
    viewBox: "0 0 20 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.7875 9.43976e-10L20 1.32315L10 12.2727L0 1.32315L1.20625 0L10 9.62003L18.7875 9.43976e-10Z",
    fill: "#d15371"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNuoliAlasRed);
export default __webpack_public_path__ + "static/media/nuoli-alas-red.6f468966f6d56ee3d6dc094d64b2922e.svg";
export { ForwardRef as ReactComponent };